/* eslint-disable react/no-unused-state */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';

class DebounceTextField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
    this.dispatchOnText = debounce(this.dispatchOnText.bind(this), 100);
  }

  handleTextChange = event => {
    const { value } = event.target;
    this.setState(
      {
        text: value,
      },
      () => this.dispatchOnText(value)
    );
  };

  dispatchOnText = value => {
    const { filter, index } = this.props;
    filter[index][0] = value;
    // onChange(filter[index], index, column);
  };

  render() {
    const { text } = this.state;
    return (
      <TextField
        value={text}
        type={this.props.type}
        onChange={this.handleTextChange}
        style={{ width: '100%' }}
      />
    );
  }
}

export default withStyles({ name: 'MuiTextField' })(DebounceTextField);
